import { useEffect } from "react";
import { GetNearestLocationIcon } from "../../Assets/assets";

export default function GetNearestLocation(props) {
  // useEffect(() => {
  //   if (props.nearestLocations?.length === 1) {
  //     props.setSelectedLocation(props.nearestLocations[0]);
  //     props.navigate("/faceIdentification/captureImage");
  //   } else if (props.nearestLocations?.length > 1) {
  //     props.navigate("/faceIdentification/multipleLocationsFound");
  //   }
  // console.log(props.nearestLocations);
  // eslint-disable-next-line
  // }, [props.nearestLocations]);

  useEffect(() => {
    // const timeout = setTimeout(() => {
    props.navigate("/faceIdentification/locationSearch");
    // }, 1000);

    // return () => clearTimeout(timeout);
    // eslint-disable-next-line
  }, []);

  return (
    <div className="inherit-parent-height inherit-parent-width padding-larger display-flex flex-direction-column">
      <div
        style={{ height: "calc(100% - 68px)" }}
        className="display-flex flex-direction-column flex-align-items-center flex-justify-content-center"
      >
        <div
          style={{
            width: "56px",
            height: "56px"
          }}
          className="margin-bottom-larger"
        >
          <div
            style={{
              transform: "translate(18px,40px)"
            }}
          >
            <div
              className="circular-loader"
              style={{ height: "24px", width: "24px" }}
              data-cy="circular-loader"
            />
          </div>

          <GetNearestLocationIcon color="var(--secondaryColor)" />
        </div>
        <div className="font-color-tertiaryColor6 padding-top-large">
          Fetching your location...
        </div>
        <div className="font-color-tertiaryColor5 text-align-center padding-top-large">
          PLEASE WAIT TILL WE GET YOUR CURRENT LOCATION
        </div>
      </div>
    </div>
  );
}
